module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kios-item"
  }, [(_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _c('div', {
    staticClass: "mt-3"
  }, [_c('v-layout', {
    staticClass: "wrap"
  }, [_c('v-flex', {
    staticClass: "pr-2 pb-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tên hồ sơ: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dossierDetail.serviceName))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-tabs', {
    attrs: {
      "color": "cyan",
      "dark": "",
      "slider-color": "yellow"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', {
    key: "1",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Thông tin chung ")]), _vm._v(" "), _c('v-tab', {
    key: "2",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Tiến trình thụ lý ")]), _vm._v(" "), (_vm.dossierDetail['dossierStatus'] === 'done') ? _c('v-tab', {
    key: "3",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadVoting()
      }
    }
  }, [_vm._v(" Đánh giá ")]) : _vm._e(), _vm._v(" "), _c('v-tab-item', {
    key: "1",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('v-layout', {
    staticClass: "px-2 py-2",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Mã hồ sơ: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.dossierNo) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Cơ quan: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.govAgencyName) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Trạng thái: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.dossierStatusText) + " ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày gửi: ")]), _vm._v(" "), (_vm.dossierDetail.online) ? _c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.submitDate) + " ")]) : _c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v(" Một cửa ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày tiếp nhận: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.receiveDate))])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày hẹn trả: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.dueDate))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(_vm.dossierDetail.dossierNote && _vm.dossierDetail.dossierNote !== 'null' && _vm.dossierDetail.dossierNote.indexOf('<br/>') < 0) ? _c('div', {
    staticClass: "xs12 sm12 pb-1",
    staticStyle: {
      "color": "#0b72ba"
    }
  }, [_vm._v("Ghi chú:")]) : _vm._e(), _vm._v(" "), (_vm.dossierDetail.dossierNote && _vm.dossierDetail.dossierNote !== 'null' && _vm.dossierDetail.dossierNote.indexOf('<br/>') < 0) ? _c('div', {
    staticClass: "xs12 sm12 pb-1 overHidden"
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "text-bold ",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.dossierDetail.dossierNote) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0",
    domProps: {
      "innerHTML": _vm._s(_vm.dossierDetail.dossierNote)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.dossierDetail.extendDate) ? _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v("Hẹn lại: " + _vm._s(_vm.dossierDetail.extendDate))])]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "2",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('div', [_c('v-data-table', {
    staticClass: "table-landing table-bordered",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.dossierActions,
      "hide-actions": "",
      "no-data-text": "Không có dữ liệu"
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("\n                        " + _vm._s(props.header.text) + "\n                      ")]), _vm._v(" "), _c('span', [_vm._v("\n                        " + _vm._s(props.header.text) + "\n                      ")])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceRole))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.durationCount) + " ngày")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("dateTimeView")(props.item.startDate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, _vm._l((props.item.assignUsers), function(itemUser) {
          return _c('div', {
            key: itemUser.userId
          }, [_vm._v("\n                        " + _vm._s(itemUser.userName) + " "), _c('br')])
        }), 0), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._l((props.item.actions), function(itemAction, index) {
          return _c('div', {
            key: index
          }, [_vm._v("\n                        " + _vm._s(_vm._f("dateTimeView")(itemAction.createDate)) + " : "), _c('span', {
            staticStyle: {
              "color": "#0b72ba"
            }
          }, [_vm._v(_vm._s(itemAction.actionName))])])
        }), _vm._v(" "), (props.item.statusText) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v(_vm._s(props.item.statusText))])]) : _vm._e()], 2)]
      }
    }])
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "3",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('div', {
    staticClass: "px-2 py-2"
  }, [_vm._l((_vm.votingItems), function(item, index) {
    return (_vm.votingItems.length > 0) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "text-bold"
    }, [_vm._v("\n                    " + _vm._s(index + 1) + ".  " + _vm._s(item.subject) + "\n                  ")]), _vm._v(" "), _c('v-radio-group', {
      staticClass: "ml-3 pt-2",
      attrs: {
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item.choices), function(item1, index1) {
      return _c('v-radio', {
        key: index1,
        attrs: {
          "label": item1,
          "value": index1 + 1
        }
      })
    }), 1), _vm._v(" "), _c('v-layout', {
      staticClass: "ml-3",
      staticStyle: {
        "margin-top": "-10px"
      },
      attrs: {
        "wrap": ""
      }
    }, _vm._l((item.answers), function(item2, index2) {
      return _c('v-flex', {
        key: index2,
        staticStyle: {
          "margin-left": "45px"
        }
      }, [_c('span', {
        staticClass: "text-bold",
        staticStyle: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(item2) + "/" + _vm._s(item.answersCount))])])
    }), 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.votingItems.length === 0) ? _c('div', {
    staticClass: "mx-3"
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "color": "warning",
      "icon": "priority_high",
      "value": true
    }
  }, [_vm._v("\n                    Không có đánh giá\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.votingItems.length > 0) ? _c('div', {
    staticClass: "ml-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loadingVoting,
      "disabled": _vm.loadingVoting
    },
    on: {
      "click": _vm.submitVoting
    }
  }, [_vm._v("Gửi đánh giá")])], 1) : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "4",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, _vm._l((_vm.listHistoryProcessing), function(item, index) {
    return _c('div', {
      key: item.dossierLogId,
      staticClass: "list_history_style"
    }, [_c('td', {
      staticClass: "px-2 pt-2",
      class: index % 2 !== 0 ? 'col-tien-trinh-1' : 'col-tien-trinh-2'
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left px-2 py-2"
    }, [_c('p', {
      staticClass: "mb-1"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("dateTimeView")(item.createDate)))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(item.author))]), _vm._v(" \n                    : "), _c('span', {
      staticStyle: {
        "color": "#0b72ba"
      }
    }, [_vm._v(_vm._s(item.payload.stepName))])]), _vm._v(" "), (item.content !== '' && item.content !== null) ? _c('p', {
      staticClass: "mb-1"
    }, [_vm._v("Ý kiến: "), _c('span', {
      staticStyle: {
        "color": "green"
      },
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]) : _vm._e()])])
  }), 0)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a934592c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a934592c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChiTietHoSo.vue
// module id = 537
// module chunks = 1